<template lang="pug">
.wrapper
    .main-container
        //- Header Global
        .relative
            HeaderGlobal(HeaderGlobalHeading="Face Recognition" :HeaderGlobalBreadcrumb="breadcrumb").py-4
            //- .mobile-only.btn-new-photo(
            //-     @click="openUpload()"
            //- )
                //- button.btn-primary-o(type='submit')
                    .icon-btn
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    span.ml-2 new photo

        .box.box--media
            .box--media__sidebar#mobileSidebarClose(
                v-bind:class="{'upload-mobile-hide' : !changePhoto }"
            )
                .mobile-only.text-light.w-full
                    .flex.items-center.justify-between.pb-4
                        h3 Upload Photo
                        button.btn-icon.btn-icon-40(
                            type='button'
                            @click="closeUpload()"
                        )
                            i.icon-btn
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                clipper-upload.btn-primary.w-full.mb-2(v-model="imgSrc" style="cursor: pointer;") Upload Photo 
                clipper-fixed.w-full.mb-2(
                    ref="clipper"
                    :src="imgSrc"
                    preview="fixed-preview"
                    :rotate="rotation"
                    :grid="true"
                    :corner="true"
                    shadow="rgba(0, 0, 0, 0.75)"
                    :ratio="ratio"
                    :wrapRatio="ratio"
                    :area="area"
                    :outline="outline"
                    :min-scale="min_scale"
                    bg-color="#000"
                    :zoomRate="zoomRate"
                )
                .range-rotate.py-1.px-2.border.rounded.mb-2.text-center
                    span.text-center.text-xs Rotate Photo
                    clipper-range(
                        v-model="rotation"
                        style="width: 100%"
                        :min="-180"
                        :max="180"
                    )

                //- .field.mb-2
                    .relative.style(style="min-width:200px")
                        select.field-style(v-model="limit")
                            option(v-if="limit.length > 0" v-for="(lim,index) in getLimit" :key="index" :value="lim") {{ lim }}
                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                //- div.flex.items-center.flex-wrap
                    .field.field--radio.mb-4(class="w-1/2")
                        .wrapper-radio
                            input(type="radio" name="radio" v-model="gender" value="male")
                            .ui-radio.flex.items-center
                                .radio.flex.items-center.justify-center
                                strong Male
                    .field.field--radio.mb-4(class="w-1/2")
                        .wrapper-radio
                            input(type="radio" name="radio" v-model="gender" value="female")
                            .ui-radio.flex.items-center
                                .radio.flex.items-center.justify-center
                                strong Female

                button.btn-primary-o.btn-large.btn-full.w-full.btn-primary--disabled(v-if="load_data_status_face_recognition.status === 'loading'" disabled="disabled" style="cursor: not-allowed;") Analyzing Photo...
                button.btn-primary-o.btn-large.btn-full.w-full(v-else @click="submit()") Analyze Photo

            .box--media__content
                .flex.area-preview
                    .area-preview__thumbnail
                        .thumbnail-result                                
                            template(v-if="serviceFR == 'openvino' || (candidates && Object.keys(candidates).length > 0)")
                                
                                template(v-if="face_recognition && face_recognition.data && face_recognition.data.faces")
                                    //- h2 Found {{ face_recognition.data.faces }} Objects
                            
                                    div.w-full.list-thumb.cursor-pointer(
                                        v-for="(candidate, index) in face_recognition.data.candidates" 
                                        :key="index"
                                    )

                                        .thumbnail-result__selected(v-if="activeIndex === index")
                                            .flex.p-2.border-b(@click="selectObj(candidate.similiar, index)")
                                                figure.cover-media
                                                    img(:src="candidate.original", @error="getDefaultImage")

                                        .block(v-else)
                                            .flex.p-2.border-b(@click="selectObj(candidate.similiar, index)")
                                                figure.cover-media
                                                    img(:src="candidate.original", @error="getDefaultImage")

                                template(v-if="faceDetected.length > 0")
                                    //- h2 Found {{ faceDetected.length }} Objects
                            
                                    div.w-full.list-thumb.cursor-pointer(
                                        v-for="(face, index) in faceDetected"
                                        :key="index"
                                    )

                                        .thumbnail-result__selected(v-if="activeIndex === index")
                                            .flex.p-2.border-b(@click="selectFace(index)")
                                                figure.cover-media
                                                    img(:src="face", @error="getDefaultImage")

                                        .block(v-else)
                                            .flex.p-2.border-b(@click="selectFace(index)")
                                                figure.cover-media
                                                    img(:src="face", @error="getDefaultImage")


                    //- .area-preview__information(style="height: 300px;")
                    .area-preview__information
                        //- h2.text-xl.mb-4 Possible related target

                        //- .preview(v-if="load_data_status_face_recognition.status === 'loading'")
                        .preview(v-if="candidatesLoading")
                            .preview-blank.flex.items-center.justify-center
                                Loading(show="true")

                        //- template(v-else-if="face_recognition.candidates && face_recognition.candidates.length > 0 && media.length > 0")

                        template(v-else-if="Object.keys(candidates).length == 0")
                            //- .preview-blank.flex.items-center.justify-center.pt-24
                            div.text-center.pt-20.pb-20
                                .inline-block.mb-2
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                h2 Data is empty
                                p There is no related targets.

                        
                        template(v-else)
                            .preview(v-for="(candidate, index) in candidates" :key="index")

                                //- .block.p-4.w-full
                                    .flex.flex-col.justify-start.items-start(
                                        class="lg:flex-row lg:items-center lg:justify-between"
                                    )
                                        .text-light.flex-grow(
                                            class="mb-6 lg:mb-0"
                                        )
                                            //- router-link(:to="media_detail.ktp_number ? '/result/'+ encryptNik(media_detail.ktp_number) +'/profile' : '/result/profile'" target="_blank")
                                            strong.block {{ media_detail.full_name }} {{ media_detail.score ? '(' + media_detail.score + ')' : '' }}
                                            span NIK : {{ media_detail.ktp_number }}
                                        .flex.items-center(
                                            class="justify-between flex-row-reverse w-full lg:flex-row lg:w-auto"
                                        )
                                            router-link.btn-default(
                                                :to="media_detail.ktp_number ? '/result/'+ encryptNik(media_detail.ktp_number) +'/profile' : '/result/profile'" target="_blank") View Detail Profile
                                            button.btn-primary.btn-full.ml-0(
                                                class="lg:ml-2"
                                            ) Save As Clue

                                .flex.-m-x-4.flex-wrap(
                                    class="flex-col-reverse lg:flex-row"
                                )
                                    .block.p-4(class="w-full lg:w-4/6").area-label-info
                                        .block
                                            .flex.mb-4.items-center.label-info
                                                span.text-light Name
                                                //- h3.monospace {{ media_detail.sex ? media_detail.sex : '-' }}

                                                template(v-if="candidate.target_id == '-' || candidate.msisdn == '-'")
                                                    h3.monospace {{ candidate.face_label }}

                                                template(v-else)
                                                    h3.monospace
                                                        router-link(:to="candidate.msisdn !== '-' ? '/target/'+ candidate.target_id +'/detail/'+ encrypt(candidate.msisdn +'&&msisdn') +'/home' : '/target/'+ candidate.target_id +'/detail/home'").link.font-bold {{ candidate.face_label }}

                                            .flex.mb-4.items-center.label-info
                                                //- .label-green.mb-4 {{ candidate.confidence }}%
                                                span.text-light Posibility
                                                h3.monospace {{ candidate.confidence }}%

                                            .flex.mb-4.items-center.label-info
                                                span.text-light Keyword
                                                h3.monospace {{ candidate.msisdn }}

                                            .flex.mb-4.items-center.label-info
                                                span.text-light Case Name
                                                h3.monospace {{ candidate.case }}

                                    .block.p-4(class="w-full lg:w-2/6")

                                        //- div.text-center(v-if="loading_photo_ktp")
                                            .inline-block
                                                Spinner(show="true" size="100")

                                        //- img(v-else :src="photo_ktp" alt="" style="width: 100% !important; height: auto !important;" @error="getDefaultImage")

                                        template(v-if="candidate.target_id == '-' || candidate.msisdn == '-'")
                                            span.block.w-56.h-56.overflow-hidden
                                                img.h-full.w-full.object-cover(:src="candidate.face_image")

                                        template(v-else)
                                            router-link(:to="candidate.msisdn !== '-' ? '/target/'+ candidate.target_id +'/detail/'+ encrypt(candidate.msisdn +'&&msisdn') +'/home' : '/target/'+ candidate.target_id +'/detail/home'").block.w-56.h-56.overflow-hidden
                                                //- img.h-full.w-full.object-cover(v-lazy="candidate.face_image")
                                                img.h-full.w-full.object-cover(:src="candidate.face_image")


                                //- .preview(v-else)
                                    .preview-blank.flex.items-center.justify-center.pt-24
                                        div.text-center
                                            template(v-if="load_data_status_face_recognition.status === 'failed'")
                                                .inline-block.mb-2
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                                h2 Failed get data
                                                p something worng

                                            template(v-else-if="load_data_status_face_recognition.status === 'empty' || load_data_status_face_recognition.status === 'partially-empty' || (load_data_status_face_recognition.status === true && media.length === 0)")
                                                .inline-block.mb-2
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                                h2 Data is empty
                                                p please try again

                                            template(v-else)
                                                .inline-block.mb-2
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-image"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
                                                h2 Please upload a photo first
                                                p the information will show when a photo has uploaded

</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from './../../components/HeaderGlobal.vue'
// import VueSlickCarousel from 'vue-slick-carousel'
// import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import { clipperFixed, clipperPreview, clipperRange, clipperUpload } from 'vuejs-clipper'
import { encrypt } from '@/util/crypto';
import Spinner from '@/components/Spinner.vue';
import Loading from '@/components/Loading.vue';
import * as faceapi from "face-api.js";

export default {
    name: 'PageFaceRecognition',
    components: {
        HeaderGlobal,
        // VueSlickCarousel,
        clipperFixed,
        clipperPreview,
        clipperRange,
        clipperUpload,
        Spinner,
        Loading,
    },
    data() {
        return {
            changePhoto: true,
            breadcrumb: [
                {
                    name: 'Face Recognition',
                    url: '/face-recognition',
                },
            ],
            rotation: 0,
            ratio: 1/1,
            outline: 6, // zoom
            // imgSrc: '',
            imgSrc: '/default-face-recognition.png',

            // default_img: this.$store.getters['config/getDefaultImageProfile'],
            default_img: '/default-face-recognition.png',

            result: '',
            pixel: '',
            area: 100,
            min_scale: 0.1,
            zoomRate: 0.1,
            candidates: {},
            activeIndex: 0,
            candidatesLoading: false,

            faceDetected: [],
            respFR: [],
            // serviceFR: this.$store.getters['config/getServiceFR'],
            serviceFR: (process.env.VUE_APP_SERVICE_FR ? process.env.VUE_APP_SERVICE_FR : 'openvino'),
            loadFaceLandmark: 'load',
            loadFaceRecog: 'load',
            loadSsdMobile: 'load',

        }
    },
    computed: {
        // ...mapState('faceRecognition', [
        ...mapState([
            // 'status_face_recognition',
            'load_data_status_face_recognition',
            'face_recognition',
        ]),
        route_name() {
            return this.$route.name;
        },
        loadLibraryFR() {
            let loadFaceLandmarkTmp = this.loadFaceLandmark
            let loadFaceRecogTmp = this.loadFaceRecog
            let loadSsdMobileTmp = this.loadSsdMobile
            // console.log({loadFaceLandmarkTmp, loadFaceRecogTmp, loadSsdMobileTmp})
            if (loadFaceLandmarkTmp=='success' && loadFaceRecogTmp=='success' && loadSsdMobileTmp=='success')
                return 'success'
            if (loadFaceLandmarkTmp=='error' || loadFaceRecogTmp=='error' || loadSsdMobileTmp=='error')
                return 'error'
            return 'load'
        },
    },
    watch: {
        route_name() {},
        imgSrc() {
            this.setEmpty();
            // this.$store.dispatch('faceRecognition/setEmpty');
            this.$store.commit('setLoadDataStatusFaceRecognition', {
                status: false,
                cancel: null,
                code: null,
            });
            this.$store.commit('setFaceRecognition', {});
        },
    },
    methods: {
        getDefaultImage(e) {
            e.target.src = this.default_img;
        },
        encrypt(string) {
            return encrypt(string);
        },
        dataURLtoFile(dataurl, filename) {
            const arr = dataurl.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n) {
                u8arr[n - 1] = bstr.charCodeAt(n - 1)
                n -= 1 // to make eslint happy
            }
            return new File([u8arr], filename, { type: mime })
        },
        setEmpty() {
            // this.$store.dispatch('faceRecognition/setEmpty');
            this.faceDetected = [];
            this.respFR = [];
            this.candidates = {};
            this.activeIndex = 0;
        },
        async selectObj(data, index) {
            this.candidatesLoading = true
            this.candidates = data
            this.activeIndex = index
            setTimeout(() => this.candidatesLoading = false, 300);
        },
        async selectFace(index) {
            console.log('index')
            console.log(index)

            this.candidatesLoading = true
            this.activeIndex = index
            if (Object.keys(this.respFR[index]).length) {
                // sudah ada response
                setTimeout(() => this.candidatesLoading = false, 300);
                this.candidates = this.respFR[index].candidates
            } else {
                // get API
                let image = await this.dataURLtoFile(this.faceDetected[index]);
                await this.getData(image, index);
                this.candidatesLoading = false;
            }

        },
        async getData(image, index = null) {
            // await this.$store.dispatch('faceRecognition/getFaceRecognition', image);
            
            // [isNew=true, image, limit='', gender='']
            await this.$store.dispatch('getFaceRecognition', [true, image]);
            
            switch(this.load_data_status_face_recognition.status) {
                case true:
                    if (this.face_recognition.data && this.face_recognition.data.candidates && this.face_recognition.data.candidates.length > 0) {
                        if(this.face_recognition.data.faces){
                            this.candidates = this.face_recognition.data.candidates[0].similiar
                        }
                        else{
                            this.candidates = this.face_recognition.data.candidates
                        }

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Done!',
                            timer: 3000,
                        });

                    } else {
                        // EventEmit.$emit('error', 'Data is empty.');
                        this.error('Data is empty.');
                    }
                    let dataFR = { // eslint-disable-line
                        candidates: [],
                        error: true,
                        message: "no faces detected"
                    }
                    let dataCandidate = {} // eslint-disable-line
                    try {
                        if("data" in this.face_recognition){
                            dataFR = this.face_recognition.data
                        } 
                    } catch (error) {} // eslint-disable-line
                    try {
                        dataCandidate = dataFR.candidates
                    } catch (error) {
                        dataCandidate = {}
                    }
                    if (index != null) {
                        this.respFR[index] = dataFR
                        this.candidates = dataCandidate
                    }
                    break;

                case 'failed':
                    // EventEmit.$emit('error');
                    this.error();
                    break;

                default:
                    // EventEmit.$emit('showLoading', false);
                    this.showLoading(false);
                    break;
            }
        },
        async submit() {
            if (this.serviceFR == 'openvino') {
                let checkLoadLib = '';
                /*eslint no-constant-condition: "off"*/
                while(true){
                    let loadLibraryFRTmp = this.loadLibraryFR
                    if (loadLibraryFRTmp=='success'){
                        // console.log('this.loadLibraryFR: success')
                        break;

                    } else if (loadLibraryFRTmp=='error'){
                        // console.log('this.loadLibraryFR: error')
                        checkLoadLib = 'error';
                        break;
                    }

                    // console.log('this.loadLibraryFR: load')
                    if (!checkLoadLib){
                        // console.log('this.loadLibraryFR: load - first load')
                        // await EventEmit.$emit('showLoading', true, 'Load Library...');
                        await this.showLoadingCustom(true, 'Load Library...');
                        checkLoadLib = 'load';
                    }
                    await this.sleep(1000);
                }

                if (checkLoadLib=='load')
                    // await EventEmit.$emit('showLoading', true, 'Searching Target...');
                    await this.showLoadingCustom(true, 'Searching Target...');
                else if (checkLoadLib=='error'){
                    // await EventEmit.$emit('showLoading', false);
                    await this.showLoadingCustom(false);
                    // await EventEmit.$emit('error', 'Something wrong with library. Please reload page');
                    await this.error('Something wrong with library. Please reload page.');

                    return;
                }
            }
            // if (this.imgSrc === '' ) {
            if (this.imgSrc === '' || this.imgSrc === '/default-face-recognition.png') {
                // EventEmit.$emit('error', 'PLease choose an image.');
                this.error('Please choose an image.');
                return;
            }

            this.setEmpty();

            // await EventEmit.$emit('showLoading', true);
            await this.showLoading(true);

            const canvas = this.$refs.clipper.clip();
            this.result = await canvas.toDataURL("image/jpeg", 1);
            let image = await this.dataURLtoFile(this.result);

            // await crop image by faces
            console.log('serviceFR: ' + this.serviceFR)
            if (this.serviceFR == 'openvino') {
                await this.detectFace(canvas)
            } else {
                this.getData(image)
            }
        },

        async detectFace(img) {
            const input = img;
            
            if (input){
                const options = new faceapi.SsdMobilenetv1Options({
                    minConfidence: 0.3,
                    maxResults: 100,
                })
                let detections = await faceapi
                .detectAllFaces(input, options)
                // .detectAllFaces(input);
                .withFaceLandmarks()
                // .withFaceExpressions()
                // .withAgeAndGender()
                .withFaceDescriptors();
                // console.log({detections})
                let responseData = '';
                if (detections && detections.length){
                    if (detections.length>1){
                        console.log('face more than 1');
                        detections.forEach((element, index) => {
                            // console.log(element)
                            this.cropFace(element.detection, index)
                        });
                    } else {
                        console.log('one face')
                        let tmpFace = await input.toDataURL("image/jpeg", 1);
                        let image = await this.dataURLtoFile(tmpFace);
                        this.getData(image, 0)
                        this.faceDetected.push(tmpFace)
                        // this.respFR.push({})
                    }
                } else {
                     // send all crop
                    // console.log('tidak jelas')
                    console.log('no face detected')
                    let tmpFace = await input.toDataURL("image/jpeg", 1);
                    let image = await this.dataURLtoFile(tmpFace);
                    this.getData(image, 0)
                    this.faceDetected.push(tmpFace)
                    // this.respFR.push({})
                }

                if (responseData!=''){
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Image Failed!',
                        text: responseData,
                    });
                }
            }
        },
        async cropFace(detection, index) {
            let box = detection._box
            let regionsToExtract = []
            // console.log('box')
            // console.log(box)
            let defPixel = 5
            let addPixel = defPixel * Math.ceil(box._height/50)         
            // console.log('addPixel')   
            // console.log(addPixel)   
            try {
                regionsToExtract = [
                    new faceapi.Rect((box._x-addPixel), (box._y-(addPixel*2)), (box._width+(addPixel*2)), (box._height+(addPixel*3)))
                ]
            } catch (error) {
                // console.log('error custom pixel')
                // console.log(error)
                regionsToExtract = [
                    new faceapi.Rect((box._x), (box._y), (box._width), (box._height))
                ]
            }
            const canvas = this.$refs.clipper.clip();
            // var tmpImg = await canvas.toDataURL("image/jpeg", 1);
            // actually extractFaces is meant to extract face regions from bounding boxes
            // but you can also use it to extract any other region
            // console.log('canvas')
            // console.log(canvas)
            const face = await faceapi.extractFaces(canvas, regionsToExtract)
            // console.log('face')
            // console.log(face[0])
            let tmpFace = await face[0].toDataURL("image/jpeg", 1);
            this.faceDetected.push(tmpFace)
            this.respFR.push({})
            if (index == 0) {
                let image = await this.dataURLtoFile(tmpFace);
                this.getData(image, index)
            } 
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        async showLoadingCustom(show=true, message=null) {
            // console.log('showLoading log')
            // console.log({show, message})
            if (show) {
                message = message ? message.toString() : 'Loading...'
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>'+message+'</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null, data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: message ? message : 'Something wrong.',
                html: errors,
                // timer: 3000
            });
        },
        async sleep(ms) {
            return new Promise((resolve) => {
                setTimeout(resolve, ms);
            });
        },
    },
    beforeMount() {
        // this.submit()
        let self = this
        faceapi.loadFaceLandmarkModel('/weight').then(()=>{
            // console.log('loadFaceLandmarkModel SUCC')
            // console.log({succ})
            self.loadFaceLandmark = 'success'
        }).catch(()=>{
            // console.log('loadFaceLandmarkModel ERR')
            // console.log({err})
            self.loadFaceLandmark = 'error'
        })
        faceapi.loadFaceRecognitionModel('/weight').then(()=>{
            // console.log('loadFaceRecognitionModel SUCC')
            // console.log({succ})
            self.loadFaceRecog = 'success'
        }).catch(()=>{
            // console.log('loadFaceRecognitionModel ERR')
            // console.log({err})
            self.loadFaceRecog = 'error'
        })
        faceapi.loadSsdMobilenetv1Model('/weight').then(()=>{
            // console.log('loadSsdMobilenetv1Model SUCC')
            // console.log({succ})
            self.loadSsdMobile = 'success'
        }).catch(()=>{
            // console.log('loadSsdMobilenetv1Model ERR')
            // console.log({err})
            self.loadSsdMobile = 'error'
        })
        // faceapi.loadTinyFaceDetectorModel('/weight');

    },
    mounted() {},
    created() {
        // this.$store.commit('faceRecognition/setFaceRecognition', {});
        this.$store.commit('setFaceRecognition', {});
    },
}
</script>

<!-- <style lang="sass" scoped>
    .ionicon
        fill: #ffffff

    .accuration
        position: absolute
        top: 0
        right: 0

    .box-upload-image
        max-width: 400px
        margin: 0 auto

    .fr-area
        padding: 2rem 0rem
        max-width: 560px
        margin: 0 auto
    .box-object
        display: flex
        align-items: center
        margin-top: 12px
        flex-wrap: wrap
        .list-object
            flex: 0 0 calc( 100% / 8 )
            img
                width: 100%
                height: 70px
                overflow: hidden
                object-fit: contain
                // object-fit: cover
                border: 4px solid transparent
                &:hover
                    opacity: 0.8
            &--active
                img
                    border-color: #70F2A1
                    &:hover
                        opacity: 1

</style> -->

<style lang="sass">
    .box--media
        display: flex
        &__sidebar
            flex: 0 0 250px
            padding: 16px
            border-style: solid
            border-right-width: 1px
        &__content
            flex-grow: 1
            position: relative

    .area-preview
        position: relative
        padding-bottom: 150px
        .area-label-info
            overflow: auto

        .label-info
            span
                width: 100%
                display: block
                max-width: 170px
            h3
                &::before
                    content: ': '
        &__information
            flex-grow: 1

        &__thumbnail
            position: relative
            flex: 0 0 300px
            .thumbnail-result
                position: absolute
                top: 0
                left: 0
                width: 300px
                height: 100%
                overflow: auto
                &::-webkit-scrollbar
                    width: 4px
                &::-webkit-scrollbar-track
                    background: $color-border
                &::-webkit-scrollbar-thumb
                    background: darken($color-border, 5% )
                    &:hover
                        background: #555
                &__selected
                    background-color: $color-secondary
                    color: $color-bg

        // .preview-blank
        //     position: absolute
        //     left: 0
        //     top: 0
        //     width: 100%
        //     height: 100%

    .cover-media
        width: 60px
        img
            width: 60px !important
            height: auto

    @media screen and (min-width: 1024px)
        .thumbnail-result
            &::-webkit-scrollbar
                width: 4px
            &::-webkit-scrollbar-track
                background: $color-border
            &::-webkit-scrollbar-thumb
                background: darken($color-border, 5% )
                &:hover
                    background: #555
    
    @media screen and (max-width: 480px)
        .btn-new-photo
            position: absolute
            bottom: 10px
            right: 18px
        .box--media
            flex-direction: column
            &__sidebar
                position: fixed
                top: 0px
                left: 0px
                width: 100vw
                height: 100vh
                overflow: auto
                background-color: $color-bg
                z-index: 9999999
                display: none
                .btn-primary
                    height: 48px
            .upload-mobile-hide
                display: block
            .analyzed-success,
                display: none
            .area-preview
                flex-direction: column
                &__thumbnail
                    position: fixed
                    bottom: 0
                    left: 0
                    z-index: 999999
                    width: 100vw
                    height: auto
                    overflow: auto
                    background-color: $color-bg
                    border-top-width: 1px
                    border-style: solid
                    .thumbnail-result
                        width: auto
                        position: relative
                        display: flex
                        .list-thumb
                            .flex
                                border-bottom: 0px !important
                                .block
                                    white-space: nowrap


</style>
